import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const getDietPreferencesAction = createAsyncThunk(
  "dietPreferences/getPreferences",
  async (_, thunkAPI) => {
    try {
      const response = await apiService.get(API_ENDPOINTS.DIET_PREFERENCES.GET);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateDietPreferencesAction = createAsyncThunk(
  "dietPreferences/updatePreferences",
  async (preferencesData, thunkAPI) => {
    try {
      const response = await apiService.put(
        API_ENDPOINTS.DIET_PREFERENCES.UPDATE,
        preferencesData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getAllDietOptionsAction = createAsyncThunk(
  "dietPreferences/getAllOptions",
  async (_, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.DIET_PREFERENCES.GET_ALL_OPTIONS
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
